export default __webpack_public_path__ + "static/proxima-nova-600-526cc6c6760d71070afc1b42f41c55ec.woff2";